import { Schema } from '@core/data/dto/schema';

export const UpdateDeliveryOrderConfigRequestSchema = {
    pickup_prep_time: Schema.Number,
    late_pickup_notification_mins: Schema.Number,
    late_dropoff_notification_mins: Schema.Number,
    pickup_notes: Schema.String,
    deliverable_action: Schema.String,
    undeliverable_action: Schema.String,
    dispatch_mode: Schema.String,
    default_customer_name: Schema.String,
    service_providers: Schema.String
};